import { createContext } from 'react';

/** An entry point outside the chat panel that hands a question to Ask Plato. */
export type AskPlatoEntryPoint = 'home_card';

/**
 * Lets feature slices start an Ask Plato conversation. The webapp's chat
 * provider owns the panel and fills this in.
 */
export type AskPlatoLauncher = {
    /** Opens the chat and sends `question` as the start of a fresh conversation. */
    askPlato: (question: string, entryPoint: AskPlatoEntryPoint) => void;
    /**
     * Opens a fresh conversation with `before` + `after` in the composer and
     * the cursor between them, for a question the user still has to complete.
     */
    draftAskPlato: (draft: { before: string; after: string }, entryPoint: AskPlatoEntryPoint) => void;
    /** Records a voice note and hands over its transcript. */
    recordVoice: (onTranscribed: (text: string) => void) => void;
};

export const AskPlatoLauncherContext = createContext<AskPlatoLauncher | undefined>(undefined);
